const KEY = 'uo:route-component-recovery';
const TTL = 60_000;

// Vue Router replaces a swallowed preload failure with this distinct error.
// Recover only a component in the actual target route, never an arbitrary 500.
export function routeComponentRecoveryPath(error, to) {
 const message = typeof error?.message === 'string' ? error.message : '';
 const match = /^Couldn't resolve component "([^"]+)" at "([^"]+)"$/.exec(message);
 if (!match || !Array.isArray(to?.matched) || !to.matched.some(record =>
  record.path === match[2] && Object.hasOwn(record.components || {}, match[1])
 )) return null;
 const path = to.fullPath;
 if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//') || /[\\\x00-\x1f]/.test(path)) return null;
 return path;
}

export function reserveRouteComponentRecovery(storage, path, now = Date.now()) {
 try {
  let previous;
  try { previous = JSON.parse(storage.getItem(KEY) || 'null'); } catch { /* Invalid old marker is replaceable. */ }
  if (previous?.expires > now) return false;
  const marker = JSON.stringify({path, expires: now + TTL});
  storage.setItem(KEY, marker);
  return storage.getItem(KEY) === marker;
 } catch {
  // Without a durable per-tab marker we cannot guarantee a bounded retry.
  return false;
 }
}
